import styled from '@emotion/styled';
import { BaseButton, Variables } from '../base';

export const Trigger = styled(BaseButton)`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-width: unset;
    height: 30px;
    padding: 0 9px 0 4px;
    font-size: 12px;
    font-weight: ${Variables.FontWeight.medium};
    color: ${Variables.ThemeLight.TextMedium};
    background: ${Variables.ThemeLight.Background2};
    background-color: ${Variables.ThemeLight.Background2};
    border: 1px solid ${Variables.ThemeLight.Border2};
    border-radius: 999px;
    cursor: pointer;
    flex: none;

    &:hover:not(:disabled) {
        background: ${Variables.ThemeLight.NeutralMild1};
        background-color: ${Variables.ThemeLight.NeutralMild1};
    }

    &:disabled {
        opacity: 0.65;
        cursor: default;
    }
`;

export const TriggerLabel = styled.span`
    font-size: 12px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.ThemeLight.TextStrong};
    white-space: nowrap;
`;

export const EmptyAvatar = styled.span`
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 1px dashed ${Variables.ThemeLight.Border2};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: none;
    color: ${Variables.ThemeLight.TextMild};
`;

export const Avatar = styled.span<{ bg: string; isYou?: boolean; size?: number }>`
    width: ${p => p.size ?? 22}px;
    height: ${p => p.size ?? 22}px;
    border-radius: 50%;
    flex: none;
    background: ${p => p.bg};
    color: ${Variables.Colors.white};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: ${p => Math.round((p.size ?? 22) * 0.4)}px;
    font-weight: ${Variables.FontWeight.semibold};
    line-height: 1;
    box-shadow: ${p =>
        p.isYou
            ? `0 0 0 2px ${Variables.ThemeLight.Background2}, 0 0 0 3.5px ${Variables.ThemeLight.PrimaryConstant6}`
            : 'none'};
`;

export const Menu = styled.div`
    width: 232px;
    padding: 5px;
    background: ${Variables.ThemeLight.Background2};
`;

export const MenuHeader = styled.div`
    font-size: 10px;
    font-weight: ${Variables.FontWeight.semibold};
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMild};
    padding: 7px 8px 6px;
`;

export const Options = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1px;
    max-height: 240px;
    overflow-y: auto;
`;

export const OptionButton = styled.button<{ selected?: boolean }>`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    text-align: left;
    background: ${p => (p.selected ? Variables.ThemeLight.NeutralMild1 : 'transparent')};
    border: none;
    border-radius: 6px;
    padding: 7px 8px;
    cursor: pointer;

    &:hover {
        background: ${Variables.ThemeLight.NeutralMild1};
    }
`;

export const OptionText = styled.span`
    min-width: 0;
    flex: 1;
`;

export const OptionName = styled.span`
    display: block;
    font-size: 12px;
    font-weight: ${Variables.FontWeight.semibold};
    line-height: 1.3;
    color: ${Variables.ThemeLight.TextStrong};
`;

export const OptionRole = styled.span`
    display: block;
    font-size: 11px;
    font-weight: ${Variables.FontWeight.medium};
    line-height: 1.3;
    color: ${Variables.ThemeLight.TextMild};
`;

export const UnassignButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    text-align: left;
    margin-top: 3px;
    border-top: 1px solid ${Variables.ThemeLight.Border2};
    border-left: none;
    border-right: none;
    border-bottom: none;
    background: transparent;
    padding: 9px 8px 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: ${Variables.FontWeight.medium};
    color: ${Variables.ThemeLight.TextMedium};

    &:hover {
        color: ${Variables.ThemeLight.TextStrong};
    }
`;

export const LoadingRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 8px;
`;
